import React from 'react';
import cn from 'classnames';
import { useHistory } from 'react-router-dom';
import { Tabs, Typography } from 'seagull';
import { useStore } from "../../../contexts";
import { selectors } from "../../../store/state-selectors";
import TabPimple from "../TabPimple";
import styles from "./AgreementMinisiteTopBar.module.scss";
import { paymentMethodModel, relationshipModel } from "../../../models";
const testPrefix = 'agreement-minisite-topbar-';
export default function AgreementMinisiteTopBar(_ref) {
  let {
    relationship,
    tabs
  } = _ref;
  const isVendorInRelationship = useStore(selectors.user.isVendorInRelationship(relationship));
  const history = useHistory();
  const tabPimples = {
    billingHub: relationshipModel.numPendingCharges(relationship),
    agreement: relationshipModel.numAmendments(relationship),
    paymentMethods: !!relationship.paymentMethod && paymentMethodModel.verificationIncomplete(relationship.paymentMethod) ? 1 : 0,
    invoices: relationshipModel.numPendingInvoices(relationship),
    activity: 0
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.topBarV2, 'hide-on-print')
  }, !relationshipModel.isPending(relationship) && /*#__PURE__*/React.createElement(Tabs, {
    "data-testid": testPrefix,
    value: location.pathname.split('/').slice(-1)[0],
    tabs: Object.entries(tabs).map(_ref2 => {
      let [tabName, {
        url,
        label,
        supportsSample
      }] = _ref2;
      return {
        id: url,
        value: url,
        component: /*#__PURE__*/React.createElement("div", {
          key: tabName,
          className: styles.tabV2
        }, /*#__PURE__*/React.createElement(Typography, null, label), !isVendorInRelationship && /*#__PURE__*/React.createElement(TabPimple, {
          className: styles.pimple,
          count: tabPimples[tabName]
        })),
        disabled: relationship.isSample && !supportsSample,
        testId: "".concat(testPrefix, "tab-").concat(tabName.toLowerCase())
      };
    })
    /* eslint-disable-next-line */

    /* @ts-ignore */
    ,
    onChange: (_, value) => {
      history.replace(value);
    }
  }));
}